import { KYMW2100Component } from './kymw2100.component';
import { OrderNumListModel } from './vo/order-num-list.model';
import { OrderNumModel } from './vo/order-num.model';
import { SearchConditionOfOrderNumModel } from './vo/search-condition-of-order-num.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { IEditableCollectionView } from '@grapecity/wijmo';


/**
 * 注文コード設定画面の値を管理するクラス
 *
 * @export KYMW2100Model
 * @class KYMW2100Model
 */
export class KYMW2100Model {

  kymw2100Component: KYMW2100Component;

  /** テキスト「受注コード」 */
  public orderCode: string = <string>'';

  /** コンボボックス「媒体」 */
  public mediumTypeList: Array<any> = new Array<any>();
  public mediumTypeListTopLineBlank: boolean = <boolean>true;                   // 先頭空白表示

  /** ラベル「フェーズ」 */
  public codeName: string = <string>'';

  /** データグリッド「注文コード一覧」 */
  public orderNumList: Array<any> = new Array<any>();

  /** 注文コード検索条件 */
  private searchConditionOfOrderNumVO: SearchConditionOfOrderNumModel = new SearchConditionOfOrderNumModel();

  /** ロック対象受注コード */
  public lockedOrderCode: string = <string>'';

  /** ロック対象媒体区分 */
  public lockedMediumType: string = <string>'';

  /** フェーズ */
  public progressWorkNum: string = <string>'';

  /** 媒体区分 */
  public mediumType: string = <string>'';

  /** 注文コード一括付番パターン */
  public orderNumSettingPattern: string = <string>'';

  /** 生協コード */
  public coopCode: string = <string>'';

  /** Ｐコード */
  public pCode: string = <string>'';

  /** 注文コード(From) */
  public orderNumFrom: string = <string>'';

  /** 注文コード(To) */
  public orderNumTo: string = <string>'';

  /** ページ番号(From) */
  public pageNumFrom: string = <string>'';

  /** ページ番号(To) */
  public pageNumTo: string = <string>'';

  /** グリッド(注文コード)読み取り専用判定 */
  public readOnlyOrderNum: boolean = <boolean>false;

  /** グリッド(注文コード一覧表)読み取り専用判定 */
  public readOnlyOrderNumList: boolean = <boolean>false;

  /** 使用注文コード(From) */
  public availableOrderNumFrom = '';

  /** 使用注文コード(To) */
  public availableOrderNumTo = '';

  /**  未付番のみ付番フラグ */
  public unnumberedOnlyFlg = true;

  /** 会員生協が必須の注文コード一括付番パターンのリスト */
  private readonly orderNumSettingPatternsRequiredCoop = ['01', '02', '03', '06'];


  /**
   * コンボボックス「媒体」のリスト（媒体、フェーズの一覧）を設定する。
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @memberof KYMW2100Model
   */
  public updateMediumTypeList(serverData: any): void {
    const tempMediumTypeList: Array<any> = serverData;
    let ob: any;
    this.clearMediumTypeList();

    // リストの先頭を空白にするか判定
    if (this.mediumTypeListTopLineBlank) {
      ob = new Object();
      ob.MediumType = '';
      ob.MediumName = '';
      ob.ProgressWorkNum = '';
      ob.CodeName = '';
      ob.OrderNumSettingPattern = '';
      ob.MediumTypeName = '';
      this.mediumTypeList.push(ob);
    }

    for (let i = Number(0); i < tempMediumTypeList.length; i++) {
      ob = new Object();
      ob.MediumType = tempMediumTypeList[i].MediumType;
      ob.MediumName = tempMediumTypeList[i].MediumName;
      ob.ProgressWorkNum = tempMediumTypeList[i].ProgressWorkNum;
      ob.CodeName = tempMediumTypeList[i].CodeName;
      ob.OrderNumSettingPattern = tempMediumTypeList[i].OrderNumSettingPattern;
      ob.MediumTypeName = ob.MediumType + ':' + ob.MediumName;
      this.mediumTypeList.push(ob);
    }
  }

  /**
   * コンボボックス「媒体」のリスト（媒体、フェーズの一覧）、及びラベル「フェーズ」をクリアする。
   *
   * @memberof KYMW2100Model
   */
  public clearMediumTypeList(): void {
    if (this.mediumTypeList == null) {
      this.mediumTypeList = new Array<any>();
    }
    this.mediumTypeList = new Array<any>();
    this.mediumType = '';
    this.codeName = '';
    this.progressWorkNum = '';
    this.orderNumSettingPattern = '';
  }

  /**
   * ラベル「フェーズ」を設定する。
   *
   * @param {String} mediumType 媒体区分
   * @memberof KYMW2100Model
   */
  public setPhase(mediumType: string): void {
    this.codeName = '';
    this.progressWorkNum = '';
    this.orderNumSettingPattern = '';

    if (!PlessViewUtilsSub.isEmptyArray(this.mediumTypeList)) {
      // 媒体、フェーズの一覧から、媒体区分が一致する要素のフェーズを返却値とする
      for (let i = Number(0); i < this.mediumTypeList.length; i++) {
        if (this.mediumTypeList[i].MediumType === mediumType) {
          this.codeName = this.mediumTypeList[i].CodeName;
          this.progressWorkNum = this.mediumTypeList[i].ProgressWorkNum;
          this.orderNumSettingPattern = this.mediumTypeList[i].OrderNumSettingPattern;
          break;
        }
      }
    }
  }

  /**
   * データグリッド「注文コード一覧」を設定する
   *
   * @param {*} serverData サーバからのレスポンスのデータ部分
   * @param {SearchConditionOfOrderNumModel} requestVO サーバへのリクエスト内容
   * @memberof KYMW2100Model
   */
  public updateOrderNumList(serverData: any, requestVO: SearchConditionOfOrderNumModel): void {
    const wkOrderNumList: Array<any> = new Array<any>();
    // データをセット
    if (!PlessViewUtilsSub.isEmptyArray(serverData)) {
      // 1 件以上の場合
      const tempOrderNumList: Array<any> = serverData;

      let orderNum: any;

      for (let i = Number(0); i < tempOrderNumList.length; i++) {
        orderNum = new Object();
        orderNum.Status = '';
        orderNum.OrderNum = this.decodeNullString(tempOrderNumList[i].OrderNum, '');
        orderNum.OrderNumInitialValue = this.decodeNullString(tempOrderNumList[i].OrderNum, '');
        orderNum.Digits3 = this.decodeString(tempOrderNumList[i].Digits, '3', '●', '');
        orderNum.Digits6 = this.decodeString(tempOrderNumList[i].Digits, '6', '●', '');
        orderNum.PCode = this.decodeNullString(tempOrderNumList[i].PCode, '');
        orderNum.GuideGoodsName = this.decodeNullString(tempOrderNumList[i].GuideGoodsName, '');
        orderNum.GuideStandardName = this.decodeNullString(tempOrderNumList[i].GuideStandardName, '');
        orderNum.PageNum = this.decodeNullString(tempOrderNumList[i].PageNum, '');
        orderNum.OrderNumSeqNo = this.decodeNullString(tempOrderNumList[i].OrderNumSeqNo, '');
        orderNum.SortPageNum = Number(orderNum.PageNum);
        orderNum.SortOrderNumSeqNo = Number(orderNum.OrderNumSeqNo);
        orderNum.CouponGoodsNo = this.decodeNullString(tempOrderNumList[i].CouponGoodsNo, '');
        orderNum.CouponName = this.decodeNullString(tempOrderNumList[i].CouponName, '');
        orderNum.CouponDiv = this.decodeNullString(tempOrderNumList[i].CouponDiv, '');
        orderNum.PreOrderDetailId = this.decodeNullString(tempOrderNumList[i].PreOrderDetailId, '');
        orderNum.ItemCode = this.decodeNullString(tempOrderNumList[i].ItemCode, '');
        orderNum.NvalDetailId = this.decodeNullString(tempOrderNumList[i].NvalDetailId, '');
        wkOrderNumList.push(orderNum);
      }
    }

    // 生成した一覧を表示
    this.orderNumList = wkOrderNumList;

    // ページネーション設定一覧の取得条件を退避
    if (requestVO == null) {
      this.searchConditionOfOrderNumVO = new SearchConditionOfOrderNumModel();
    } else if (requestVO.CoopCode === '*') {
      // 全生協指定の場合は、検索条件をクリア
      this.searchConditionOfOrderNumVO = new SearchConditionOfOrderNumModel();
    } else {
      this.searchConditionOfOrderNumVO = requestVO;
    }
  }

  /**
   * 注文コード一覧の検索条件を返す
   *
   * @returns {SearchConditionOfOrderNumModel} 注文コード一覧の検索条件
   * @memberof KYMW2100Model
   */
  public getSearchConditionOfOrderNumVO(): SearchConditionOfOrderNumModel {
    return this.searchConditionOfOrderNumVO;
  }

  /**
   * データグリッド「注文コード一覧」をクリアする
   *
   * @memberof KYMW2100Model
   */
  public clearOrderNumList(): void {
    this.orderNumList = new Array<any>();
  }

  /**
   * データグリッド「注文コード一覧」の指定行の「ステータス」を更新する
   *
   * @param {number} index ステータスを更新する行
   * @memberof KYMW2100Model
   */
  public setStatusOrderNumList(index: number): void {
    const list: IEditableCollectionView = this.kymw2100Component.dtg_OrderNumList.editableCollectionView;
    const orderCode: string = PlessViewUtilsSub.trim(list.items[index]['OrderNum']);
    const orderNumInitialValue: string = PlessViewUtilsSub.trim(list.items[index]['OrderNumInitialValue']);

    if (orderCode !== orderNumInitialValue) {
      list.items[index]['Status'] = '変';
    }

    this.onSourceChangeSelectedMark(index);
  }

  /**
   *
   *
   * @param {number} index
   * @memberof KYMW2100Model
   */
  public onSourceChangeSelectedMark(index: number) {
    this.kymw2100Component.dtg_OrderNumList.autoSizeRow(index);
  }

  /**
   * データグリッド「注文コード一覧」を初期値に戻す
   *
   * @memberof KYMW2100Model
   */
  public resetOrderNumList(): void {
    if (!PlessViewUtilsSub.isEmptyArray(this.orderNumList)) {
      for (let i = Number(0); i < this.orderNumList.length; i++) {
        this.orderNumList[i]['Status'] = '';

        const orderCode: string = this.orderNumList[i]['OrderNumInitialValue'];
        this.orderNumList[i]['OrderNum'] = orderCode;
      }
    }
  }

  /**
   * データグリッド「注文コード一覧」の指定セルの値を変更する
   *
   * @param {number} row 行（インデックス値）
   * @param {string} colomnName 列（インデックス名）
   * @param {string} value 値
   * @memberof KYMW2100Model
   */
  public setOrderNumListCell(row: number, colomnName: string, value: string): void {
    this.orderNumList[row][colomnName] = value;
  }

  /**
   * データグリッド「注文コード一覧」の行数を返す
   *
   * @returns {number} 注文コード一覧の行数
   * @memberof KYMW2100Model
   */
  public getOrderNumListCount(): number {
    if (this.orderNumList == null) {
      this.orderNumList = new Array<any>();
    }

    return this.orderNumList.length;
  }

  /**
   * データグリッド「注文コード一覧」の表示を更新する（セルの値を変更後に使用）
   *
   * @memberof KYMW2100Model
   */
  public refreshOrderNumList(): void {
    this.kymw2100Component.dtg_OrderNumList.refresh();
  }

  /**
   * データグリッド「注文コード一覧」から、ステータスが変更ありとなっている注文コードVOの一覧を取得する。
   *
   * @returns {Array<any>} 注文コードVOの一覧
   * @memberof KYMW2100Model
   */
  public getChangedOrderNumVOList(): Array<any> {
    const orderNumVOList: Array<any> = new Array<any>();

    if (!PlessViewUtilsSub.isEmptyArray(this.orderNumList)) {
      for (let i = Number(0); i < this.orderNumList.length; i++) {
        const status: string = this.orderNumList[i]['Status'];

        if (status === '変') {
          const vo: OrderNumModel = new OrderNumModel;
          vo.OrderNum = this.orderNumList[i]['OrderNum'];
          vo.PCode = this.orderNumList[i]['PCode'];
          vo.ItemCode = this.orderNumList[i]['ItemCode'];
          vo.CouponGoodsNo = this.orderNumList[i]['CouponGoodsNo'];
          vo.CouponDiv = this.orderNumList[i]['CouponDiv'];
          vo.PreOrderDetailId = this.orderNumList[i]['PreOrderDetailId'];
          vo.NvalDetailId = this.orderNumList[i]['NvalDetailId'];

          orderNumVOList.push(vo);
        }
      }
    }

    return orderNumVOList;
  }

  /**
   * データグリッド「注文コード一覧」に、指定の注文コードが何件存在するかを返却する。
   *
   * @param {String} targetOrderNum 注文コード
   * @returns {number} 指定の注文コードの件数
   * @memberof KYMW2100Model
   */
  public getOrderNumCount(targetOrderNum: string): number {
    let orderCodeCount = Number(0);

    if (!PlessViewUtilsSub.isEmptyArray(this.orderNumList)) {
      for (let i = Number(0); i < this.orderNumList.length; i++) {
        const orderNum: string = this.orderNumList[i]['OrderNum'];

        if (orderNum === targetOrderNum) {
          orderCodeCount++;
        }
      }
    }

    return orderCodeCount;
  }

  /**
   * 対象がnullの場合、指定の文字列に置き換える
   *
   * @param {String} target 処理対象の文字列
   * @param {String} swap 置換する文字列
   * @returns {String} 置換後の文字列
   * @memberof KYMW2100Model
   */
  public decodeNullString(target: string, swap: string): string {
    let returnString: string = target;

    if (PlessViewUtilsSub.isEmpty(target)) {
      returnString = swap;
    }

    return returnString;
  }

  /**
   * 対象が特定の文字列の場合、指定の文字列に置き換える
   *
   * @param {String} target 処理対象の文字列
   * @param {String} check 検索する文字列
   * @param {String} swap1 一致した場合に置換する文字列
   * @param {String} swap2 一致しなかった場合に置換する文字列
   * @returns {String} 置換後の文字列
   * @memberof KYMW2100Model
   */
  public decodeString(target: string, check: string, swap1: string, swap2: string): string {
    let returnOrderCode: string = swap2;

    if (target === check) {
      returnOrderCode = swap1;
    }

    return returnOrderCode;
  }

  /**
   * 選択されている媒体が会員生協が必要な媒体かどうかを判定
   */
  public isRequiredCoop() {
    return this.orderNumSettingPatternsRequiredCoop.includes(this.orderNumSettingPattern);
  }

  /**
   * 検索条件(任意)項目をクリアする
   *
   * @memberof KYMW2100Model
   */
  public clearOptionalFilters(): void {
    this.pCode = '';
    this.orderNumFrom = '';
    this.orderNumTo = '';
    this.pageNumFrom = '';
    this.pageNumTo = '';
  }
}
